import { formDataPostCall, getCall } from "./axiosCalls";

export const getLocations = async (values) => {
    try {
        console.log(values)
        const response = await getCall(
          process.env.REACT_APP_API_LINK + "/racks/get",
          {
            requester: 1,
            token: 'sample token',
            ...values
          }
        );
        console.log(response);
        return { data: response.data.data };
    } catch (error) {
        console.log(error)
        return { error: error };
    }
}

export const getItems = async (values) => {
    try {
        const response = await getCall(
          process.env.REACT_APP_API_LINK + "/items/get",
          {
            requester: 1,
            token: 'sample token',
            ...values
          }
        );
        console.log(response);
        return { data: response.data.data };
    } catch (error) {
        console.log(error)
        return { error: error };
    }
}

export const getAvailableLocations = async (values) => {
    try {
        console.log(values)
        const response = await getCall(
          process.env.REACT_APP_API_LINK + "/racks/get_levels",
          values
        );
        console.log(response);
        console.log(response.data);
        return { data: response.data.data };
    } catch (error) {
        console.log(error)
        return { error: error };
    }
}

//POST
export const createLocation = async (values) => {
    let form_data = new FormData();
    form_data.append("requester", 1); //static 
    form_data.append("token", 'static sample token'); //static 
    form_data.append("name", values.name || "");
    form_data.append("row", values.row || "");
    form_data.append("column", values.column || "");
    form_data.append("remarks", values.remarks || "");

    values.levels?.map(level => {
        form_data.append("level[]", level.level || "");
        form_data.append("maximum_qty[]", level.maximum_qty || "");
        form_data.append("temperature[]", level.temperature || "");
        // form_data.append("temperature_to[]", level.temperature_type === "in-range" ? level.temperature_to : level.temperature_from );
        // form_data.append("temperature_type[]", level.temperature_type || "exact");
    })

    try {
        const response = await formDataPostCall(
          process.env.REACT_APP_API_LINK + "/racks/create", // Ex. "/racks/create"
          form_data
        );
        console.log(response);
        return { data: response.data };
    } catch (error) {
        console.log(error)
        return { error: error.response };
    } 
}
//POST
export const updateLocation = async (values) => {
    let form_data = new FormData();
    form_data.append("requester", 1); //static 
    form_data.append("token", 'static sample token'); //static 
    form_data.append("rack_id", values.rack_id || "");
    form_data.append("name", values.name || "");
    form_data.append("row", values.row || "");
    form_data.append("column", values.column || "");
    form_data.append("remarks", values.remarks || "");

    values.levels?.map(level => {
        form_data.append("rack_level_id[]", level.rack_level_id || null);
        form_data.append("level[]", level.level || "");
        form_data.append("maximum_qty[]", level.maximum_qty || "");
        form_data.append("temperature[]", level.temperature || "");
        // form_data.append("temperature_to[]", level.temperature_type === "in-range" ? level.temperature_to : level.temperature_from );
        // form_data.append("temperature_type[]", level.temperature_type || "exact");
    })

    try {
        const response = await formDataPostCall(
          process.env.REACT_APP_API_LINK + "/racks/update",
          form_data
        );
        console.log(response);
        return { data: response.data };
    } catch (error) {
        console.log(error)
        return { error: error.response };
    } 
}